import { NEW_LANDINGI_URL } from '@config/env'
import PartyPopper from '@images/checkout/party-popper.svg'
import { LANDINGS, PAYMENTS } from '@routes/path'
import {
  Button,
  Heading,
  Image,
  Layout,
  Paragraph,
  Spacer,
  Spreader
} from '@ui-kit'
import { ConfettiExplosion } from 'react-confetti-explosion'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Column, Row } from 'simple-flexbox'

import { ExpertPanel } from './components/ExpertPanel'
import { PaymentInfoPanel } from './components/PaymentInfoPanel'

export const Confirmation = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleGoToPlanAndPayments = () => {
    window.open(`https://${NEW_LANDINGI_URL}${PAYMENTS.SUBSCRIPTION}`, '_self')
  }

  const handleGoToLandingPages = () => {
    navigate(LANDINGS.LANDINGS)
  }

  return (
    <Layout width={1070}>
      <Row alignItems='center' justifyContent='center'>
        <ConfettiExplosion
          force={0.8}
          duration={3000}
          particleCount={250}
          width={1070}
        />
      </Row>

      <Spacer space={40} />
      <Column justifyContent='center' alignItems='center'>
        <Image src={PartyPopper} />

        <Spacer space={10} />

        <Heading weight={600} data-testid='confirmation-heading'>
          {t('checkout.confirmation.heading')}
        </Heading>

        <Spacer space={10} />

        <Paragraph size={18}>
          {t('checkout.confirmation.description.your.payment.went.through')}
        </Paragraph>

        <Paragraph size={18}>
          {t('checkout.confirmation.description.we.are.excited.to.have.you')}
        </Paragraph>

        <Spacer space={40} />

        <Row>
          <ExpertPanel />

          <Spreader spread={30} />

          <PaymentInfoPanel />
        </Row>

        <Spacer space={40} />

        <div
          style={{
            display: 'grid',
            gap: '30px',
            gridTemplateColumns: '1fr 1fr'
          }}
        >
          <Button
            variant='outlined'
            onClick={handleGoToPlanAndPayments}
            size={16}
            data-testid='go-to-plan-and-payments-button'
          >
            {t('checkout.confirmation.button.go.to.plan.and.payments')}
          </Button>

          <Button
            onClick={handleGoToLandingPages}
            size={16}
            data-testid='go-to-landing-pages-button'
          >
            {t('checkout.confirmation.button.go.to.landing.pages')}
          </Button>
        </div>
      </Column>
    </Layout>
  )
}

Confirmation.displayName = 'CheckoutConfirmation'
